import Vue from 'vue'
import { createBrowserHistory } from 'history'

import ContinueBanner from './components/ContinueBanner'
import Page01 from './components/Page-01'
import Page02 from './components/Page-02'
import Page03 from './components/Page-03'
import Page03iFrame01 from './components/Page-03-iFrame-01'
import Page04 from './components/Page-04'
import Page05 from './components/Page-05'
import Page06 from './components/Page-06'
import Page07 from './components/Page-07'
import Page08 from './components/Page-08'
import Page09 from './components/Page-09'
import Page10 from './components/Page-10'
import Page11 from './components/Page-11'
import Page12 from './components/Page-12'
import Page12iFrame01 from './components/Page-12-iFrame-01'
import Page13 from './components/Page-13'
import Page14 from './components/Page-14'
import Page15 from './components/Page-15'
import Page16 from './components/Page-16'
import Page17 from './components/Page-17'
import Page18 from './components/Page-18'
import Page19 from './components/Page-19'
import Page20 from './components/Page-20'
import Page20iFrame01 from './components/Page-20-iFrame-01'
import Page21 from './components/Page-21'
import Page21iFrame01 from './components/Page-21-iFrame-01'
import Page22 from './components/Page-22'
import Page22iFrame01 from './components/Page-22-iFrame-01'
import Page23 from './components/Page-23'
import Page23iFrame01 from './components/Page-23-iFrame-01'
import Page24 from './components/Page-24'
import Page24iFrame01 from './components/Page-24-iFrame-01'
import Page25 from './components/Page-25'
import Page25iFrame01 from './components/Page-25-iFrame-01'
import Page26 from './components/Page-26'
import Page26iFrame01 from './components/Page-26-iFrame-01'
import Page27 from './components/Page-27'
import Page27iFrame02 from './components/Page-27-iFrame-02'
import Page28 from './components/Page-28'
import Page28iFrame02 from './components/Page-28-iFrame-02'
import Page29 from './components/Page-29'
import Page29iFrame01 from './components/Page-29-iFrame-01'
import Page30 from './components/Page-30'
import Page31 from './components/Page-31'
import Page31iFrame01 from './components/Page-31-iFrame-01'
import Page32 from './components/Page-32'
import Page32iFrame01 from './components/Page-32-iFrame-01'
import Page33 from './components/Page-33'
import Page33iFrame01 from './components/Page-33-iFrame-01'
import Page34 from './components/Page-34'
import Page34iFrame01 from './components/Page-34-iFrame-01'
import Page35 from './components/Page-35'
import Page35iFrame01 from './components/Page-35-iFrame-01'
import Page36 from './components/Page-36'
import Page36iFrame01 from './components/Page-36-iFrame-01'
import Page37 from './components/Page-37'
import Page37iFrame01 from './components/Page-37-iFrame-01'
import Page38 from './components/Page-38'
import Page38iFrame01 from './components/Page-38-iFrame-01'

import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

const history = createBrowserHistory()
global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $

new Vue({
  el: '#demotourapp',
  /////////////////////////////////////////////////////
  // Data
  /////////////////////////////////////////////////////
  data() {
    return {
      step: 0,
      dataLoaded: false
    }
  },
  /////////////////////////////////////////////////////
  // Components
  /////////////////////////////////////////////////////
  components: {
    'continue-banner': ContinueBanner,
    'page-01': Page01,
    'page-02': Page02,
    'page-03': Page03,
    'page-03-iframe-01': Page03iFrame01,
    'page-04': Page04,
    'page-05': Page05,
    'page-06': Page06,
    'page-07': Page07,
    'page-08': Page08,
    'page-09': Page09,
    'page-10': Page10,
    'page-11': Page11,
    'page-12': Page12,
    'page-12-iframe-01': Page12iFrame01,
    'page-13': Page13,
    'page-14': Page14,
    'page-15': Page15,
    'page-16': Page16,
    'page-17': Page17,
    'page-18': Page18,
    'page-19': Page19,
    'page-20': Page20,
    'page-20-iframe-01': Page20iFrame01,
    'page-21': Page21,
    'page-21-iframe-01': Page21iFrame01,
    'page-22': Page22,
    'page-22-iframe-01': Page22iFrame01,
    'page-23': Page23,
    'page-23-iframe-01': Page23iFrame01,
    'page-24': Page24,
    'page-24-iframe-01': Page24iFrame01,
    'page-25': Page25,
    'page-25-iframe-01': Page25iFrame01,
    'page-26': Page26,
    'page-26-iframe-01': Page26iFrame01,
    'page-27': Page27,
    'page-27-iframe-02': Page27iFrame02,
    'page-28': Page28,
    'page-28-iframe-02': Page28iFrame02,
    'page-29': Page29,
    'page-29-iframe-01': Page29iFrame01,
    'page-30': Page30,
    'page-31': Page31,
    'page-31-iframe-01': Page31iFrame01,
    'page-32': Page32,
    'page-32-iframe-01': Page32iFrame01,
    'page-33': Page33,
    'page-33-iframe-01': Page33iFrame01,
    'page-34': Page34,
    'page-34-iframe-01': Page34iFrame01,
    'page-35': Page35,
    'page-35-iframe-01': Page35iFrame01,
    'page-36': Page36,
    'page-36-iframe-01': Page36iFrame01,
    'page-37': Page37,
    'page-37-iframe-01': Page37iFrame01,
    'page-38': Page38,
    'page-38-iframe-01': Page38iFrame01,
  },
  /////////////////////////////////////////////////////
  // Mounted
  /////////////////////////////////////////////////////
  mounted() {
    $(document).on('click', 'a', function (e) {
      if (!$(this).hasClass('dont-prevent')) {
        e.preventDefault()

        if (!($(this).hasClass('dont-shake'))) {
          $('.dt-step').removeClass('dt-step-attention')
          setTimeout(function () {
            $('.dt-step').addClass('dt-step-attention')
          }, 1)
          setTimeout(function () {
            $('.dt-step').removeClass('dt-step-attention')
          }, 500)
        }

        return false
      } else {
        return true
      }
    })

    $(document).on('click', 'button', function (e) {
      if (!$(this).hasClass('dont-prevent')) {
        e.preventDefault()

        if (!($(this).hasClass('dont-shake')) && !($(this).parent().hasClass('dt-step__cta--button'))) {
          $('.dt-step').removeClass('dt-step-attention')
          setTimeout(function () {
            $('.dt-step').addClass('dt-step-attention')
          }, 1)
          setTimeout(function () {
            $('.dt-step').removeClass('dt-step-attention')
          }, 500)
        }

        return false
      } else {
        return true
      }
    })

    if (!history.location.hash) {
      location.hash = 1
      this.step = 1
    } else {
      this.step = parseInt(location.hash.replace('#', ''))
    }

    // const unlisten = history.listen((location, action) => {
    //   this.step = parseInt(location.hash.replace('#', ''))
    // })

    this.setContinueCookie()
    this.dataLoaded = true
  },
  /////////////////////////////////////////////////////
  // Methods
  /////////////////////////////////////////////////////
  methods: {
    nextStep(data) {
      this.step = data
      this.setContinueCookie()
      location.hash = this.step
    },
    prevStep(data) {
      this.step = data
      this.setContinueCookie()
      location.hash = this.step
    },
    setContinueCookie () {
      let url = window.top.location.pathname
      let filename = url.substring(url.lastIndexOf('/')+1)

      // the won't set a cookie for the intro or the outro
      if (filename.length && filename !== 'outro.html') {
        this.$cookie.set('continuePage', url, { expires: '1Y' })
        this.$cookie.set('continueStep', this.step, { expires: '1Y' })
      }

      if (filename === 'outro.html') {
        this.$cookie.delete('continuePage')
        this.$cookie.delete('continueStep')
      }
    }
  }

})
